var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-main"},[_c('div',{staticClass:"item-icon"},[_c('i',{ref:"icon",staticClass:"material-icons icon-size"},[_vm._v("lens")])]),_c('div',{staticClass:"item-label"},[_c('label',{staticClass:"label-font"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }